import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FeaturedPlayListIcon from "@mui/icons-material/FeaturedPlayList";
import React, { useContext, useMemo } from "react";
import { useTextDomainContext } from "@/app/providers";

interface MenuItemSubscriptionProps<
  TRow extends object = Record<string, unknown>,
> {
  row?: TRow;
  menuFor?: string;
  handleClose: () => void;
  menuClick: (_action: string, _row?: TRow) => void;
  showItems?: Record<string, boolean | undefined>;
}

export const MenuItemSubscription = <
  TRow extends object = Record<string, unknown>,
>(
  props: MenuItemSubscriptionProps<TRow>,
): React.ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  //#region useMemo

  const menuFor = useMemo(() => {
    return props.menuFor ?? "";
  }, [props.menuFor]);

  //#endregion useMemo

  //#region Handlers

  const handleClose = () => {
    props.handleClose();
  };

  const handleEditAction = () => {
    props.menuClick(`${menuFor}-edit`, props.row);
    handleClose();
  };

  const handleFeaturesAction = () => {
    props.menuClick(`${menuFor}-features`, props.row);
    handleClose();
  };

  const handleDeleteAction = () => {
    props.menuClick(`${menuFor}-delete`, props.row);
    handleClose();
  };

  //#endregion Handlers

  return (
    <>
      {props?.showItems?.showEdit && (
        <MenuItem onClick={handleEditAction}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Edit")} />
        </MenuItem>
      )}

      {props?.showItems?.showFeatures && (
        <MenuItem onClick={handleFeaturesAction}>
          <ListItemIcon>
            <FeaturedPlayListIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Features")} />
        </MenuItem>
      )}

      {props?.showItems?.showDelete && (
        <MenuItem onClick={handleDeleteAction}>
          <ListItemIcon>
            <DeleteIcon color="error" fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary={gettext("Delete")}
            slotProps={{
              primary: {
                color: "error",
              },
            }}
          />
        </MenuItem>
      )}
    </>
  );
};
